import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

import { NavLink } from 'react-router-dom';

const StyledMenu = styled(Flexer.Parent).attrs(() => ({ flex: 'center' }))``;

const StyledItem = styled(NavLink)`
  white-space: nowrap;
  font-weight: normal;
  height: 4.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: var(--grey700);
  padding: 0 ${(props) => props.theme.base.gridSizes.S};
`;

const ItemWrapper = ({ className, ...props }) => (
  <StyledItem {...props} activeClassName={className} />
);

ItemWrapper.propTypes = {
  className: PropTypes.string.isRequired,
};

const StyledMenuItem = styled(ItemWrapper)`
  box-shadow: inset 0 -4px 0 var(--primary-top-bar-color);
  color: var(--primary-top-bar-color);
  font-weight: bold;
`;

export { StyledMenu, StyledMenuItem };
